<template>
    <component :is="product" />
</template>

<script>
import { mapGetters } from 'vuex'

import PublicCatalogProduct from '@/components/Public/Catalog/Product/PublicCatalogProduct.vue'
import RetailerCatalogProduct from '@/components/Public/Catalog/Product/RetailerCatalogProduct.vue'

export default {
    name: 'PublicCatalogProductID',

    components: {
        PublicCatalogProduct,
        RetailerCatalogProduct
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        product() {
            return this.isRetailer
                ? RetailerCatalogProduct
                : PublicCatalogProduct
        }
    }
}
</script>
